<template>
<div style="background:#fff;">
     <div ref="headarea">
        <slot  name="toolbar"></slot>
    </div> 
    <Card  :padding="0" :bordered="false"  style="padding-top:0px;padding-left:16px;padding-right:16px;padding-bottom:14px;"  dis-hover>
           <Row type="flex"  justify="start"  :gutter="0" :style="style2">
            <Col  :span="formCol">
                <FormCardGroupBoxs ref="form"  :config="myConfig.formsConfig" :dictData="dictData" @doAction="doAction"/>
                <div v-for="(temp2,index) in detailConfig.items" :id="'detail_'+index" v-show="detailVisible[index].visible" >
                    <EditGridCardS  v-if="temp2.type === 'EditGridCard'" :ref="temp2.name" :config="temp2" :dictData="dictData" @doAction="doAction"/>
                    <DetailsBoxs  v-if="temp2.type === 'DetailsBox'" :ref="temp2.name"      :config="temp2" :dictData="dictData" @doAction="doAction"/>
                    <FormCardBox  v-if="temp2.type === 'FormCardBox'" :ref="temp2.name"     :config="temp2" :dictData="dictData"/>
                    <AppendixBoxs  v-if="temp2.type === 'AppendixBox'" :ref="temp2.name"   :config="temp2" :modulecode="modulecode" @doAction="doAction"/>
                    <OperLog  v-if="temp2.type === 'OperLogBox'" :ref="temp2.name"   :config="temp2"  @doAction="doAction"/>
                </div>
            </Col>
            <Col v-if="showAnchorLink" :span="anchorCol" style="background-color:#fff;">
                <Anchor style="padding-left:10px;" class="efuture-anchor" :offset-top="offsetTop" :show-ink="false" @on-select="anchorChange" @on-change="anchorChange">
                        <AnchorLink v-for="temp in anchorData" :class="anchorid == temp.id?'ivu-anchor-link-active':''" :href="temp.id"  v-show="temp.visible" :title="temp.name" style="margin-bottom:5px;margin-top:5px"/>
                </Anchor>
            </Col>
        </Row>
    </Card>
</div>
</template>
<script>
import elementResizeDetectorMaker from 'element-resize-detector'
import FormCardGroupBoxs from './formcardgroupbox.vue';
import EditGridCardS from './editgridcard.vue';
import DetailsBoxs from './detailsbox.vue';
import AppendixBoxs from './appendix.vue';
import OperLog from './operlog.vue';
export default {
    name:'billdetailform',
    components:{FormCardGroupBoxs,EditGridCardS,DetailsBoxs,AppendixBoxs,OperLog},
    data () {
        return {
            curlEditObject:'',
            title:'单据详情',
            showOperLog:true,
            singleForm:{},
            readOnly:false,
            showAnchorLink:false,
            operVisible:true,
            approvalVisible:true,
            rowBtnVisible:false,
            showBtnToolbar:true,
            anchorData:[],
            anchorCol:3,
            formCol:21,
            myConfig:{
                saveModel:'whole', // whole整体保存，part局部
                adjustHeight:0,
                showApprovalLog:false,
                approvalConfig:{}
            },
            detailVisible:[],
            menuToolbar:{

            },
            anchorid:'',
            detailConfig:{},
            offsetTop: 0,
            editFlag:false,
            extraHeight:0,
            outsideHeight:0,
            modulecode:'',
            billAppendixConfig:{
                showAppendix:false,
                appendixKey:'billno'
            },
            billOperLogConfig:{
                showOperLog:false,
                operLogKey:'billno'
            },
            billapprovalUrl:''
        };
    },
    created () {
        this.myConfig = Object.assign({}, this.myConfig, this.config);
        if (this.myConfig.showBtnToolbar !== undefined) {
            this.showBtnToolbar = this.myConfig.showBtnToolbar;
        }
        let modetype = '1';
        if (this.myConfig.modetype !== undefined) {
            modetype = this.myConfig.modetype;
        }
        if (this.myConfig.formsConfig.items.length  > 0){
            if (!this.myConfig.formsConfig.lineNum) {
                this.myConfig.formsConfig.lineNum = 3;
            }
           
            this.myConfig.formsConfig.items.forEach((el, index) => {
                if (el.name === undefined) {
                    el.name = 'headForm_' + index; 
                }
                if (el.lineNum === undefined) {
                    el.lineNum = this.myConfig.formsConfig.lineNum;
                }
                 if (el.labelWidth === undefined) {
                     el.labelWidth = 100;
                }
                if (!el.title && index === 0) {
                    el.title = this.title;
                }
                el.modetype = modetype;
                this.anchorData.push({id:'#'+el.name ,name:el.title,visible:true,refname:el.name,isHead:true});
            });
        }
       
        if (this.myConfig.billDetailConfig !== undefined) {
            this.detailConfig = Object.assign({}, this.detailConfig, this.myConfig.billDetailConfig);
            this.detailVisible = [];
            if (this.detailConfig.items) {
                this.detailConfig.items.forEach((el, index) => {
                    if (el.type === 'EditGridCard') {
                        el.generalOrientation = true; 
                        if (el.dynamicHeight === undefined) {
                            el.dynamicHeight = true;
                        }
                        if (el.height === undefined) {
                            if (el.dynamicHeight !== false) {
                                el.height = 840;
                            } else {
                                el.height = 260;
                            }
                        }
                        el.showBorder = true;
                        if (el.editItemMaxNum === undefined){
                            el.editItemMaxNum = 20;
                        }
                    }
                    el.modetype = modetype;
                    this.detailVisible.push({refname:el.name,visible:true});
                    this.anchorData.push({id:'#detail_'+index, name:el.title,refname:el.name,visible:true,isHead:false});
                });
            }
        }
        if (this.myConfig.billAppendixConfig) {
           this.billAppendixConfig = Object.assign({}, this.billAppendixConfig, this.myConfig.billAppendixConfig);     
        }
        if (this.myConfig.billOperLogConfig) {
           this.billOperLogConfig = Object.assign({}, this.billOperLogConfig, this.myConfig.billOperLogConfig);     
        }
        if (this.myConfig.modulecode !== undefined) {
            this.modulecode = this.myConfig.modulecode;
        }
        
         if (this.billAppendixConfig.showAppendix) {
            let tmp = Object.assign({}, {}, this.billAppendixConfig);
            tmp.type = 'AppendixBox';
            tmp.name = 'detail_appenndix';
            tmp.title = '附件';
            this.detailConfig.items.push(tmp);
            this.detailVisible.push({refname:tmp.name,visible:true});
            this.anchorData.push({id:'#detail_' + this.detailConfig.items.length, name:tmp.title,refname:tmp.name,visible:true});
        }

        if (this.billOperLogConfig.showOperLog) {
            let tmp = Object.assign({}, {}, this.billOperLogConfig);
            tmp.type = 'OperLogBox';
            tmp.name = 'detail_operlog';
            tmp.title = '操作日志';
            this.detailConfig.items.push(tmp);
            this.detailVisible.push({refname:tmp.name,visible:true});
            this.anchorData.push({id:'#detail_' + this.detailConfig.items.length, name:tmp.title,refname:tmp.name,visible:true});
        }

        if (this.myConfig.showAnchorLink !== undefined) {
            this.showAnchorLink = this.myConfig.showAnchorLink;
        }
        if (this.showAnchorLink) {
            if (this.myConfig.anchorCol) {
                this.anchorCol = this.myConfig.anchorCol;
                this.formCol = 24 - Number(this.anchorCol);
            } else {
                this.anchorCol = 3;
                this.formCol = 21;
            }
        } else {
            this.anchorCol = 0;
            this.formCol = 24;
        }

        if (this.myConfig.menuToolbar) {
            this.menuToolbar = this.$Method.copy(this.myConfig.menuToolbar);
        }

        if (this.myConfig.billisworkflow) {
           this.menuToolbar.billisworkflow = this.myConfig.billisworkflow;
        }

    },
    updated() {
        this.offsetTop = 64;
    },
    computed:{
        style2 () {
            let height = this.$Store.state.app.clientHeight  - this.extraHeight - this.outsideHeight - 40;
            if (this.showAnchorLink) {
                return 'overflow-y: auto;min-height:' + height + 'px;overflow-x: hidden;';
            } else {
                return 'overflow-y: auto;height:' + height + 'px;overflow-x: hidden;';
            }
        }
    },
    
    methods:{
        doAction (obj) {
            if (obj.name === 'editGrid' || obj.name === 'cancelGrid') {
                this[obj.name](obj);
            } else {
                if (obj.name === 'addData') {
                    this.curlEditObject = '';
                }
                this.$emit('doAction' , obj);
            }
        },
        doRowBtn () {
            if (this.myConfig.rowBtnMethod) {
                let obj = {};
                obj.name = this.myConfig.rowBtnMethod;
                this.$emit('doAction' , obj);
            }
        },
        anchorClick(id) {
            let temp = this.anchorData.find(el => el.id === id);
            if (temp && temp.refname) {
                if (this.$refs[temp.refname]) {
                    if (this.$refs[temp.refname] instanceof Array) {
                        if (this.$refs[temp.refname][0]) {
                            if (this.$refs[temp.refname][0].setShowGrid) {
                                this.$refs[temp.refname][0].setShowGrid(true);
                            } else {
                                this.$refs.form.setShowForm(true,temp.refname);
                            }
                        }
                    } else {
                        if (this.$refs[temp.refname].setShowGrid) {
                            this.$refs[temp.refname].setShowGrid(true);
                        } else {
                            this.$refs[temp.refname].setShowForm(true);
                        }
                    }
                } else {
                     this.$refs.form.setShowForm(true,temp.refname);
                }
            }
        },
        anchorChange(id) {
            if (id === '#') {
                this.anchorid = this.anchorData[0].id;
            } else {
                this.anchorid = id;
            }
            this.anchorClick(this.anchorid);
        },
        setVisibleCommon(name , value) {
            let index = this.anchorData.findIndex(el2 => el2.refname === name);
            if (index > -1) {
                let temp = Object.assign({}, this.anchorData[index], {visible:value});
                this.anchorData.splice(index ,1, temp);
                if (!this.anchorData[index].isHead) {
                    if (this.detailVisible && this.detailVisible.length > 0) {
                        let indexConfig = this.detailVisible.findIndex(el3 => el3.refname === name);
                        if (indexConfig > -1) {
                            let config = Object.assign({}, this.detailVisible[indexConfig], {visible:value});
                            this.detailVisible.splice(indexConfig ,1, config);
                        }
                    }
                } else {
                    this.$refs.form.setVisible(name, value);
                }
            }
        },
        setRowBtnVisible(value) {
            this.rowBtnVisible = value;
        },
        setData(data) {
            this.$refs.form.setData(data);
            if (this.detailConfig.items) {
                this.detailConfig.items.forEach(el => {
                    if (data[el.name]) {
                        if (this.$refs[el.name] && this.$refs[el.name][0]) {
                            if (el.type === 'DetailsBox') {
                                let tempDetailData = this.setDetailsBox(el, data);
                                this.$refs[el.name][0].setData(tempDetailData);
                            } else {
                                if (el.type === 'FormCardBox') {
                                    if (data[el.name].length > 0) {
                                        this.$refs[el.name][0].setData(data[el.name][0]);
                                    } else {
                                        this.$refs[el.name][0].clearData();
                                    }
                                } else {
                                    this.$refs[el.name][0].setData(data[el.name]);
                                }
                            } 
                        }
                    } else {
                        if (this.config.response === el.name) {
                            if (el.type === 'FormCardBox') {
                                let temp = {};
                                if (el.items) {
                                    el.items.forEach(el2 => {
                                        if (el2.name) {
                                            temp[el2.name] = data[el2.name];
                                        }
                                        if (el2.sname) {
                                            temp[el2.sname] = data[el2.sname];
                                        }
                                        if (el2.ename) {
                                            temp[el2.ename] = data[el2.ename];
                                        }
                                        if (el2.textName) {
                                            temp[el2.textName] = data[el2.textName];
                                        }
                                    });
                                }
                                this.$refs[el.name][0].setData(temp);
                            }
                        } else {
                            if (el.type !== 'AppendixBox' && el.type !== 'OperLogBox') {
                                if (this.$refs[el.name] && this.$refs[el.name][0]) {
                                    this.$refs[el.name][0].setData([]);
                                }
                            }
                        }
                    }
                });
            }
            if (this.billAppendixConfig.showAppendix) {
                if (this.$refs.detail_appenndix && this.$refs.detail_appenndix[0]) {
                    let billno = data[this.billAppendixConfig.appendixKey];
                    this.$refs.detail_appenndix[0].setData(billno);
                }
            }
              if (this.billOperLogConfig.showOperLog) {
                if (this.$refs.detail_operlog && this.$refs.detail_operlog[0]) {
                    let billno = data[this.billOperLogConfig.operLogKey];
                    this.$refs.detail_operlog[0].setData(billno);
                }
            }
            this.$nextTick(() => {
                setTimeout(()=>{
                    this.curlEditObject = '';
                    this.doAnchorClick();
                },250);
            });
        },
        setDetailsBox(el,  data) {
            let form = data[el.name];
            if (el.gridConfig.items && el.gridConfig.items.length > 0 && el.gridName) {
                let gridData = data[el.gridName];
                if (form && form.length > 0) {
                    form.forEach(el2 => {
                        el2[el.gridName] = [];
                        gridData.forEach(el3 => {
                            if (el2[el.uniqueKeys] === el3[el.uniqueKeys]) {
                                el2[el.gridName].push(el3);
                            }
                        });
                    });
                }
            }
            return form;
        },
        getChangeData (detialsname) {
            let data = this.$refs.form.getData();
            for (let pro in data) {
                if (data[pro] instanceof Array) {
                    if (data[pro].length === 0) {
                        delete data[pro];
                    } else {
                        let temp = [];
                        data[pro].forEach(el => {
                            if (el.flag !== undefined) {
                                temp.push(el);
                            }
                        });
                        if (temp.length > 0) {
                            data[pro] = temp;
                        } else {
                            delete data[pro];
                        }
                    }
                }
            }
            if (!data[this.myConfig.billKey]) {
                data.flag = 'I';
            } else {
                data.flag = 'U';
            }

            if (this.detailConfig.items) {
                if (detialsname) {
                    let name = [];
                    if (detialsname instanceof Array) {
                        name = detialsname;
                    } else {
                        name.push(detialsname);
                    }
                    name.forEach(el => {
                        let config = this.detailConfig.items.find(el2 => el2.name === el);
                        if (config) {
                            this.getCommonChangeData(data, config);
                        }
                    });
                    this.detailConfig.items.forEach(el => {
                        let index = name.findIndex(el2 => el.name === el2);
                        if (index === -1) {
                            if (el.gridName) {
                                delete data[el.gridName];
                            }
                            delete data[el.name];
                        }
                    });
                } else {
                    this.detailConfig.items.forEach(el => {
                        this.getCommonChangeData(data, el);
                    });
                }
                
            }
            return data;
        },
        getCommonChangeData(data, el) {
            if (el.name === 'detail_appenndix' || el.name === 'detail_operlog') {
                return;
            }
            if (this.$refs[el.name] && this.$refs[el.name][0]) {
                if (el.type === 'DetailsBox') {
                    Object.assign(data, this.getDetailsBox(el));
                } else if (el.type === 'FormCardBox') {
                    if (this.config.response === el.name) {
                        Object.assign(data, this.getFormCardBox(el));
                    } else {
                        let temp = this.getFormCardBox(el,true);
                        if (!temp[this.myConfig.billKey]) {
                            temp.flag = 'I';
                        } else {
                            temp.flag = 'U';
                        }
                        data[el.name] = [temp];
                    }
                } else {
                    data[el.name] = this.$refs[el.name][0].getChangeData();
                }
            }
        },
        getFormCardBox (el, flag) {
            let data = this.$refs[el.name][0].getData();
            if (flag) {
                return data;
            }
            let obj = {};
            if (el.items) {
                el.items.forEach(el2 => {
                    if (el2.name) {
                        obj[el2.name] = data[el2.name];
                    }
                    if (el2.sname) {
                        obj[el2.sname] = data[el2.sname];
                    }
                    if (el2.ename) {
                        obj[el2.ename] = data[el2.ename];
                    }
                    if (el2.textName) {
                        obj[el2.textName] = data[el2.textName];
                    }
                });
            }
            return obj;
        },
        getDetailsBox(el) {
            let name = el.name;
            let form = this.$refs[name][0].getChangeData();
            let obj = {};
            if (el.gridConfig.items && el.gridConfig.items.length > 0 && el.gridName) {
                let gridData = [];
                if (form && form.length > 0) {
                    form.forEach(el2 => {
                        if (el2[el.gridName] && el2[el.gridName].length > 0) {
                            if (el2.flag !== 'D') {
                                el2[el.gridName].forEach(el3 => {
                                    if (el3.flag !== undefined) {
                                        gridData.push(el3);
                                    }
                                });
                            } else {
                                el2[el.gridName].forEach(el3 => {
                                    if (el3[this.myConfig.billKey] !== undefined) {
                                        el3.flag = 'D';
                                        gridData.push(el3);
                                    }
                                });
                            }
                        }
                        delete el2[el.gridName];
                    });
                }
                if (gridData.length > 0) {
                    obj[el.gridName] = gridData;
                } else {
                    obj[el.gridName] = [];
                }
            }
            if (form.index) {
                delete form.index;
            }
            obj[el.name] = form;
            return obj;
        },
        getData() {
            let data = this.$refs.form.getData();
            if (this.detailConfig.items) {
                this.detailConfig.items.forEach(el => {
                    if (this.$refs[el.name] && this.$refs[el.name][0]) {
                        if (this.config.response === el.name) {
                            let tempData = this.$refs[el.name][0].getData();
                            let temp = {};
                            if (el.items) {
                                el.items.forEach(el2 => {
                                    if (el2.name) {
                                        temp[el2.name] = tempData[el2.name];
                                    }
                                    if (el2.sname) {
                                        temp[el2.sname] = tempData[el2.sname];
                                    }
                                    if (el2.ename) {
                                        temp[el2.ename] = tempData[el2.ename];
                                    }
                                    if (el2.textName) {
                                        temp[el2.textName] = tempData[el2.textName];
                                    }
                                });
                            }
                            Object.assign(data,temp);
                        } else {
                            if (el.type !=='OperLogBox') {
                                data[el.name] = this.$refs[el.name][0].getData();
                            }
                        }
                      
                    }
                });
            }
            return data;
        },
        getDetailData(name) {
            let data = [];
            if (this.$refs[name] && this.$refs[name][0]) {
                data = this.$refs[name][0].getData();
            }
            return data;
        },
        setReadOnly(value) {
            this.readOnly = value;
            this.$refs.form.setFormReadOnly(value);
            if (this.detailConfig.items) {
                this.detailConfig.items.forEach(el => {
                    if (this.$refs[el.name] && this.$refs[el.name][0]) {
                        if (el.type === 'FormCardBox') {
                            this.$refs[el.name][0].setFormReadOnly(value);
                        } else {
                            if (el.type !== 'OperLogBox') {
                                this.$refs[el.name][0].setReadOnly(value); 
                            }
                        }
                      
                    }
                });
            }
        },
        isChange (){
            if (this.readOnly) {
                return false;
            }
            let flag = this.$refs.form.isChange();
            if (!flag) {
                if (this.detailConfig.items) {
                    this.detailConfig.items.forEach(el => {
                        if (!flag) {
                            if (el.name !== 'detail_appenndix' && el.name !== 'detail_operlog') {
                                if (this.$refs[el.name] && this.$refs[el.name][0]) {
                                    flag = this.$refs[el.name][0].isChange();
                                }
                            }
                        }
                    });
                }
            }
            return flag;
        },
        isEdit () {
            let flag = false;
            if (this.detailConfig.items) {
                this.detailConfig.items.some(el => {
                    if (el.type === 'DetailsBox') {
                        if (this.$refs[el.name] && this.$refs[el.name][0]) {
                            if (this.myConfig.modeType === 'part') {
                                if (el.name !== this.curlEditObject) {
                                    flag = this.$refs[el.name][0].isEdit();
                                }
                            } else {
                                flag = this.$refs[el.name][0].isEdit();
                            }
                        }
                    }
                    if (flag) {
                        return true;
                    }
                });
            }
            return flag;
        },
        clearData() {
            this.billno = '';
            this.billstatus = '';
            this.$refs.form.clearData();
            if (this.detailConfig.items) {
                this.detailConfig.items.forEach(el => {
                    if (this.$refs[el.name] && this.$refs[el.name][0]) {
                        this.$refs[el.name][0].clearData();
                    }
                });
            }
        },
        checkValidate () {
            let flag = false;
            flag = this.$refs.form.checkValidate();
            if (!flag) {
                if (this.detailConfig.items) {
                    this.detailConfig.items.some((el,index) => {
                        if (!flag) {
                            if (this.detailVisible[index].visible) {
                                flag = this.checkCommonValidate(el);
                            }
                            if (flag) {
                                return true;
                            }
                        }
                    });
                    
                }
            }
            return flag;
        },
        checkCommonValidate(el) {
            let flag = false;
            if (this.$refs[el.name] && this.$refs[el.name][0] && this.$refs[el.name][0].checkValidate) {
                if (el.type === 'FormCardBox') {
                    this.$refs[el.name][0].checkValidate();
                    flag = this.$refs[el.name][0].isError();
                } else {
                    flag = this.$refs[el.name][0].checkValidate();
                }
            }
            return flag;
            
        },
        getForm (name) {
            return this.$refs.form.getForm(name);
        },
        getDetail(name) {
            if (this.$refs[name] && this.$refs[name][0]) {
                return this.$refs[name][0];
            } else {
                return null;
            }
        },
        getDetailTitle(name) {
            let index = this.anchorData.findIndex(el => el.refname === name);
            if (index > -1) {
                return this.anchorData[index].name;
            }
            return '';
        },
        editObjectBefore(name) {
            if (this.curlEditObject) {
                if (name && name === this.curlEditObject) {
                    return true;
                } else {
                    this.alert('存在数据未保存');
                    return false;
                }
            }
            return true;
        },
        editForm(obj) {
            this.curlEditObject = obj.formname;
            this.setMenuToolbar(true);
        },
        cancelForm() {
            this.curlEditObject = '';
            this.setMenuToolbar(false);
        },
        editGrid(obj) {
            this.curlEditObject = obj.gridname;
            this.setMenuToolbar(true);
        },
        cancelGrid() {
            this.curlEditObject = '';
            this.setMenuToolbar(false);
        },
        setAllBtnReadOnly(value) {
            this.myConfig.formsConfig.items.forEach(el => {
                this.getForm(el.name).setBtnReadOnly(value);
            });
            if (this.detailConfig.items) {
                this.detailConfig.items.forEach(el => {
                    if (this.$refs[el.name] && this.$refs[el.name][0]) {
                        if (this.config.response !== el.name) {
                            this.$refs[el.name][0].setBtnReadOnly(value); 
                        }
                    }
                });
            }
        },
        setBtnReadOnly(name, value) {
            this.myConfig.formsConfig.items.forEach(el => {
                if (el.name === name) {
                    this.getForm(el.name).setBtnReadOnly(value);
                }
            });
            if (this.detailConfig.items) {
                this.detailConfig.items.forEach(el => {
                    if (this.$refs[el.name] && this.$refs[el.name][0]) {
                        if (this.config.response !== el.name && el.name === name) {
                            this.$refs[el.name][0].setBtnReadOnly(value); 
                        }
                    }
                });
            }
        },
        setVisible (name,value) {
            this.setVisibleCommon(name, value);
        },
        setExtraHeight () {
            let height = 0;
            if (this.$refs.headarea) {
                height = this.$refs.headarea.offsetHeight;
            }
            this.extraHeight = height;
        },
        setOutsideHeight(value) {
            this.outsideHeight = value;
        },
        delAppenndix() {
            if (this.billAppendixConfig.showAppendix) {
                this.$refs.detail_appenndix[0].dellAllfile();
            }
        },
        updateAllfile() {
            if (this.billAppendixConfig.showAppendix) {
                if (this.billAppendixConfig.notdelfile) {
                    this.$refs.detail_appenndix[0].updateAllfile();
                }
            }
        },
        doAnchorClick() {
            if (this.showAnchorLink) {
                if (this.anchorData.length > 0) {
                    this.anchorid = this.anchorData[0].id;
                    this.anchorClick(this.anchorData[0].id);
                }
            }
        },
        getApprovalData() {
            let data = this.$refs.form.getData();
            let obj = {};
            obj.billno = data.billno;
            obj.billmoduleid = data.billmoduleid;
            obj.billstatus = data.billstatus;
            obj.statusName = obj.billstatus;
            if (this.dictData.BILLSTATUS) {
                let tmp = this.dictData.BILLSTATUS.find(el => el.code === obj.billstatus); 
                if (tmp) {
                    obj.statusName = tmp.name;
                }
            }
        }
    },
    props:{
        config: {
            type:Object,
            default:null
        },
        dictData: {
            type: Object,
            default: () => {
                return {};      
            }
        },
        moduleMethod:{
            type:Array,
            default: () => {
                return [];      
            }
        }
    },
    mounted () {
        this.observer = elementResizeDetectorMaker();
        this.observer.listenTo(this.$refs.headarea, this.setExtraHeight);
        //this.observer.listenTo(this.$refs.title, this.setExtraHeight);
    },
    beforeDestroy() {
        this.observer.removeListener(this.$refs.headarea, this.setExtraHeight);
        //this.observer.removeListener(this.$refs.title, this.setExtraHeight);
    }
};
</script>



// WEBPACK FOOTER //
// src/components/masterplate/billdetailform.vue